export type TNativeBiquadFilterNode = BiquadFilterNode;
